/* ==========================================================================
   Planetry Prints · product pages, collections and studio story
   --------------------------------------------------------------------------
   - Planet Posters lineup + rail (snippets/pp-poster-lineup, pp-poster-card)
   - Sky Code "How to read it" diagram (snippets/pp-skycode-diagram; needs
     assets/pp-skycode.js for the numbers)
   - Planet poster product page: gallery, options, price, ?variant=
     (sections/pp-poster-product; adding to the bag stays with Dawn's
     <product-form>, so the cart drawer opens and updates as usual)
   - the small live orrery ("Want your own date?"), loaded on approach
   - annotations that draw on entry, studio cross-sell links that carry the
     shopper's date, and image fallbacks for theme images still on their way
   Every init is idempotent; safe to include more than once.
   ========================================================================== */
(function () {
  'use strict';
  if (window.PPProduct) return;

  var doc = document;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var NS = 'http://www.w3.org/2000/svg';
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
    'August', 'September', 'October', 'November', 'December'];

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function easeTravel(t) { /* cubic-bezier(0.65, 0, 0.35, 1), close enough as an in-out cubic */
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }
  function easeEnter(t) { return 1 - Math.pow(1 - t, 3); }
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function todayISO() {
    if (window.PP && PP.todayISO) return PP.todayISO();
    var t = new Date();
    return t.getFullYear() + '-' + pad(t.getMonth() + 1) + '-' + pad(t.getDate());
  }
  function validISO(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s || '');
    if (!m) return false;
    var d = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]));
    return d.getUTCMonth() === +m[2] - 1 && d.getUTCDate() === +m[3];
  }
  function formatDate(iso) {
    if (window.PP && PP.formatDate) return PP.formatDate(iso);
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
    return m ? (+m[3]) + ' ' + MONTHS[+m[2] - 1] + ' ' + m[1] : '';
  }
  function behavior() { return reduce.matches ? 'auto' : 'smooth'; }
  function onView(el, cb, opts) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); cb(); } });
    }, opts || { rootMargin: '0px 0px -10% 0px', threshold: 0.25 });
    io.observe(el);
  }
  /* Prices as the site writes them (snippets/pp-money): C$29, US$21. */
  function money(cents, code) {
    code = code || 'CAD';
    var value = cents / 100, digits = value % 1 ? 2 : 0;
    var prefix = code === 'CAD' ? 'C$' : code === 'USD' ? 'US$' : '';
    try {
      if (prefix) return prefix + new Intl.NumberFormat('en-CA', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(value);
      return new Intl.NumberFormat('en-CA', { style: 'currency', currency: code, minimumFractionDigits: digits, maximumFractionDigits: digits }).format(value);
    } catch (_) { return (prefix || '$') + value.toFixed(digits); }
  }

  /* ---- images that may not have arrived yet --------------------------------- */
  function initImages(scope) {
    (scope || doc).querySelectorAll('img[data-pp-fallback], img[data-pp-optional]').forEach(function (img) {
      if (img.ppImg) return;
      img.ppImg = true;
      var fail = function () {
        var fb = img.getAttribute('data-pp-fallback');
        if (fb && img.src.indexOf(fb) === -1) { img.removeAttribute('srcset'); img.src = fb; return; }
        if (img.hasAttribute('data-pp-optional')) {
          var gone = img.closest('[data-pp-optional-host]');
          if (gone) { gone.hidden = true; gone.setAttribute('data-pp-missing', ''); }
          else img.remove();
        }
      };
      img.addEventListener('error', fail);
      if (img.complete && img.naturalWidth === 0 && img.getAttribute('src')) fail();
    });
  }

  /* ---- the lineup ------------------------------------------------------------ */
  function initLineup(root) {
    if (root.ppLineup) return;
    root.ppLineup = true;
    var mode = root.getAttribute('data-mode') || 'rail';
    var track = root.querySelector('.pp-lineup__track');
    var marker = root.querySelector('.pp-lineup__marker');
    var dots = Array.prototype.slice.call(root.querySelectorAll('.pp-lineup__dot'));
    var rail = root.querySelector('.pp-lineup__rail');
    var scope = mode === 'rail' ? root : (root.closest('[data-pp-lineup-page]') || root.closest('.shopify-section') || doc);
    if (!track || !dots.length) return;

    function cardFor(world) { return scope.querySelector('[data-pp-world="' + world + '"]'); }
    function dotFor(world) { return root.querySelector('.pp-lineup__dot[data-world="' + world + '"]'); }
    function colW() { return track.clientWidth / dots.length; }
    function place(fa, fb) {
      var w = colW();
      fa = clamp(fa, 0, dots.length); fb = clamp(fb, 0, dots.length);
      if (fb - fa < 0.5) { var mid = (fa + fb) / 2; fa = mid - 0.25; fb = mid + 0.25; }
      marker.style.setProperty('--pp-mx', (fa * w) + 'px');
      marker.style.setProperty('--pp-mw', Math.max(10, (fb - fa) * w) + 'px');
      marker.classList.add('is-on');
      var center = Math.floor((fa + fb) / 2);
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i >= Math.floor(fa + 0.15) && i < Math.ceil(fb - 0.15)); });
      return center;
    }

    /* hover a dot: lift its card; hover a card: mark its dot */
    dots.forEach(function (d) {
      var world = d.getAttribute('data-world');
      var on = function () { var c = cardFor(world); if (c) c.classList.add('is-lifted'); d.classList.add('is-hover'); };
      var off = function () { var c = cardFor(world); if (c) c.classList.remove('is-lifted'); d.classList.remove('is-hover'); };
      d.addEventListener('pointerenter', on);
      d.addEventListener('pointerleave', off);
      d.addEventListener('focus', on);
      d.addEventListener('blur', off);
      d.addEventListener('click', function () {
        var c = cardFor(world);
        if (!c) return;
        if (mode === 'rail' && rail) {
          var slot = c.closest('.pp-lineup__slot') || c;
          rail.scrollTo({ left: slot.offsetLeft - (rail.clientWidth - slot.offsetWidth) / 2, behavior: behavior() });
        } else {
          c.scrollIntoView({ block: 'center', behavior: behavior() });
        }
      });
    });
    scope.querySelectorAll('[data-pp-world]').forEach(function (c) {
      var d = dotFor(c.getAttribute('data-pp-world'));
      if (!d) return;
      c.addEventListener('pointerenter', function () { d.classList.add('is-hover'); });
      c.addEventListener('pointerleave', function () { d.classList.remove('is-hover'); });
    });

    if (mode === 'rail' && rail) {
      var slots = function () { return rail.querySelectorAll('.pp-lineup__slot'); };
      var update = function () {
        var s = slots();
        if (!s.length) return;
        var first = s[0], stride = s.length > 1 ? s[1].offsetLeft - first.offsetLeft : first.offsetWidth;
        if (!stride) return;
        var gap = stride - first.offsetWidth;
        var a = (rail.scrollLeft + (parseFloat(getComputedStyle(rail).scrollPaddingLeft) || 0) - first.offsetLeft) / stride;
        var b = (rail.scrollLeft + rail.clientWidth - first.offsetLeft + gap) / stride;
        place(Math.max(0, a), Math.min(s.length, b));
      };
      var ticking = false;
      rail.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; update(); });
      }, { passive: true });
      window.addEventListener('resize', update);

      /* the current poster's card starts in view, without animation */
      var cur = root.getAttribute('data-current');
      var cc = cur && cardFor(cur);
      if (cc) {
        var slot = cc.closest('.pp-lineup__slot') || cc;
        rail.scrollLeft = Math.max(0, slot.offsetLeft - (rail.clientWidth - slot.offsetWidth) / 2);
      }
      update();

      /* scrub: drag along the lineup to move the rail */
      var dragging = false, startX = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        dragging = true; moved = false; startX = e.clientX;
      });
      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        if (!moved && Math.abs(e.clientX - startX) < 6) return;
        if (!moved) { moved = true; rail.style.scrollSnapType = 'none'; root.classList.add('is-scrubbing'); }
        var r = track.getBoundingClientRect();
        var f = clamp((e.clientX - r.left) / r.width, 0, 1);
        rail.scrollLeft = f * (rail.scrollWidth - rail.clientWidth);
      });
      var end = function () {
        if (!dragging) return;
        dragging = false;
        if (moved) {
          rail.style.scrollSnapType = '';
          root.classList.remove('is-scrubbing');
          /* swallow the click that ends a drag, and only that one */
          var swallow = function (ev) { ev.stopPropagation(); ev.preventDefault(); };
          track.addEventListener('click', swallow, true);
          setTimeout(function () { track.removeEventListener('click', swallow, true); moved = false; }, 60);
        }
      };
      window.addEventListener('pointerup', end);
      window.addEventListener('pointercancel', end);
    } else {
      /* grid: the marker follows the card nearest the middle of the screen */
      var cards = Array.prototype.slice.call(scope.querySelectorAll('[data-pp-world]'));
      var gridUpdate = function () {
        var mid = window.innerHeight / 2, best = null, bestD = Infinity;
        cards.forEach(function (c) {
          var r = c.getBoundingClientRect();
          if (r.bottom < 0 || r.top > window.innerHeight) return;
          var dd = Math.abs((r.top + r.bottom) / 2 - mid) + Math.abs((r.left + r.right) / 2 - window.innerWidth / 2) * 0.05;
          if (dd < bestD) { bestD = dd; best = c; }
        });
        if (!best) { marker.classList.remove('is-on'); dots.forEach(function (d) { d.classList.remove('is-active'); }); return; }
        var i = dots.indexOf(dotFor(best.getAttribute('data-pp-world')));
        if (i >= 0) place(i + 0.2, i + 0.8);
      };
      var gt = false;
      window.addEventListener('scroll', function () {
        if (gt) return;
        gt = true;
        requestAnimationFrame(function () { gt = false; gridUpdate(); });
      }, { passive: true });
      window.addEventListener('resize', gridUpdate);
      gridUpdate();
    }
  }

  /* ---- Sky Code diagram ---------------------------------------------------------
     Earth's ring, the arc traveled by the date, then that arc unrolling (its
     curvature easing to zero while its foot travels to Earth's bar) into the bar. */
  var LAYOUTS = {
    wide: { W: 640, H: 280, cx: 124, cy: 132, r: 92, ringLabelY: 262, x0: 350, x1: 606, top: 50, base: 222, lettersY: 250, barW: 10, font: 12,
            arrow: [240, 132, 300, 132] },
    tall: { W: 360, H: 470, cx: 180, cy: 108, r: 84, ringLabelY: 220, x0: 56, x1: 304, top: 286, base: 420, lettersY: 446, barW: 10, font: 12,
            arrow: [180, 232, 180, 262] }
  };

  function svgEl(tag, attrs, parent) {
    var n = doc.createElementNS(NS, tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  function f2(v) { return Math.round(v * 100) / 100; }

  function Diagram(fig) {
    this.fig = fig;
    this.art = fig.querySelector('[data-pp-skydia-art]');
    this.dateEl = fig.querySelector('[data-pp-skydia-date]');
    this.date = validISO(fig.getAttribute('data-date')) ? fig.getAttribute('data-date') : todayISO();
    this.played = false;
    this.layoutName = null;
    this.build();
    var self = this;
    if (reduce.matches) { this.played = true; this.draw(Infinity); }
    else {
      this.draw(0);
      onView(fig, function () { self.play(); }, { rootMargin: '0px 0px -15% 0px', threshold: 0.4 });
    }
    var rt = null;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        if (self.pickLayout() !== self.layoutName) { self.build(); self.draw(self.played && !self.playing ? Infinity : self.lastT || 0); }
      }, 150);
    });
    if (fig.getAttribute('data-live') === 'true') {
      doc.addEventListener('pp:studio-update', function () { self.follow(); });
      setTimeout(function () { self.follow(); }, 0);
    }
  }

  Diagram.prototype.pickLayout = function () {
    var forced = this.fig.getAttribute('data-layout');   /* the homepage slides ask for 'wide' on computers (pp-slides.js) */
    if (forced === 'wide' || forced === 'tall') return forced;
    return (this.art.clientWidth || this.fig.clientWidth || 640) < 520 ? 'tall' : 'wide';
  };

  Diagram.prototype.follow = function () {
    var f = doc.querySelector('pp-case-customizer [data-date]');
    var v = f && f.value;
    if (validISO(v) && v !== this.date) this.setDate(v);
  };

  Diagram.prototype.setDate = function (iso) {
    if (!validISO(iso)) return;
    this.date = iso;
    this.compute();
    if (!this.playing) this.draw(this.played ? Infinity : 0);
  };

  Diagram.prototype.compute = function () {
    var SC = window.PPSkyCode;
    this.days = SC && SC.orbitDays ? SC.orbitDays(this.date) : null;
    var label = formatDate(this.date).toUpperCase();
    if (this.dateEl) {
      this.dateEl.textContent = label;
      this.dateEl.hidden = !!this.dateLabel;      /* written on the ring instead (data-date-at="orbit") */
    }
    if (this.dateLabel) { this.dateLabel.textContent = label; this.placeDate(); }
    if (this.days) {
      var e = this.days.earth;
      this.svg.setAttribute('aria-label', 'Your Sky Code for ' + formatDate(this.date) +
        ': Earth\'s orbit drawn as a ring, with the ' + Math.round(e.frac * 100) + ' percent it had traveled by that date (day ' +
        e.day + ' of ' + e.period + ') straightening into Earth\'s blue bar, beside one bar for each planet from Mercury to Pluto.');
    }
  };

  Diagram.prototype.build = function () {
    var L = LAYOUTS[this.layoutName = this.pickLayout()];
    this.L = L;
    this.art.innerHTML = '';
    var svg = svgEl('svg', { viewBox: '0 0 ' + L.W + ' ' + L.H, role: 'img', class: 'pp-skydia__svg', focusable: 'false' }, this.art);
    this.svg = svg;
    var g = svgEl('g', { fill: 'none', 'stroke-linecap': 'round', 'stroke-linejoin': 'round' }, svg);
    this.ring = svgEl('path', { class: 'pp-skydia__ring', stroke: 'currentColor', 'stroke-width': 1.25, 'stroke-opacity': 0.42 }, g);
    this.tick = svgEl('line', { x1: L.cx + L.r - 7, y1: L.cy, x2: L.cx + L.r + 7, y2: L.cy, stroke: 'currentColor', 'stroke-width': 1.25, 'stroke-opacity': 0.7 }, g);
    this.sun = svgEl('circle', { cx: L.cx, cy: L.cy, r: 9, fill: '#F8B400', stroke: 'none' }, g);
    this.arc = svgEl('path', { stroke: '#12A8E8', 'stroke-width': 3 }, g);
    this.earth = svgEl('circle', { r: 5, fill: '#12A8E8', stroke: 'none' }, g);
    /* the date, beside Earth where it stood on its ring (the homepage case: data-date-at="orbit") */
    this.dateLabel = this.fig.getAttribute('data-date-at') === 'orbit'
      ? svgEl('text', { class: 'pp-skydia__label pp-skydia__datelabel', fill: 'currentColor', stroke: 'none', 'font-size': L.font + 2 }, svg)
      : null;
    this.ringLabel = svgEl('text', { x: L.cx, y: L.ringLabelY, 'text-anchor': 'middle', class: 'pp-skydia__label', fill: 'currentColor', stroke: 'none', 'font-size': L.font }, svg);
    this.ringLabel.textContent = 'ONE ORBIT';
    var a = L.arrow;
    this.arrow = svgEl('g', { stroke: 'currentColor', 'stroke-width': 1.25, 'stroke-opacity': 0.6 }, g);
    svgEl('line', { x1: a[0], y1: a[1], x2: a[2], y2: a[3] }, this.arrow);
    var ang = Math.atan2(a[3] - a[1], a[2] - a[0]);
    svgEl('path', { d: 'M' + f2(a[2] - 7 * Math.cos(ang - 0.5)) + ' ' + f2(a[3] - 7 * Math.sin(ang - 0.5)) + ' L' + a[2] + ' ' + a[3] +
      ' L' + f2(a[2] - 7 * Math.cos(ang + 0.5)) + ' ' + f2(a[3] - 7 * Math.sin(ang + 0.5)) }, this.arrow);

    /* the code: two rails, nine bars, the letters */
    var xs = [], dx = (L.x1 - L.x0) / 8;
    for (var k = 0; k < 9; k++) xs.push(L.x0 + k * dx);
    this.xs = xs;
    var rx0 = L.x0 - 18, rx1 = L.x1 + 18, cxm = (L.x0 + L.x1) / 2;
    this.code = svgEl('g', {}, g);
    var gapHalf = 62;
    svgEl('line', { x1: rx0, y1: L.top, x2: cxm - gapHalf, y2: L.top, stroke: 'currentColor', 'stroke-width': 1.25, 'stroke-opacity': 0.75 }, this.code);
    svgEl('line', { x1: cxm + gapHalf, y1: L.top, x2: rx1, y2: L.top, stroke: 'currentColor', 'stroke-width': 1.25, 'stroke-opacity': 0.75 }, this.code);
    svgEl('line', { x1: rx0, y1: L.base, x2: rx1, y2: L.base, stroke: 'currentColor', 'stroke-width': 1.25, 'stroke-opacity': 0.75 }, this.code);
    var railLabel = svgEl('text', { x: cxm, y: L.top + L.font * 0.36, 'text-anchor': 'middle', class: 'pp-skydia__label', fill: 'currentColor', stroke: 'none', 'font-size': L.font - 1 }, this.code);
    railLabel.textContent = 'ONE FULL ORBIT';
    var letters = (window.PPSkyCode && PPSkyCode.LETTERS) || ['M', 'V', 'E', 'M', 'J', 'S', 'U', 'N', 'P'];
    for (var j = 0; j < 9; j++) {
      var t = svgEl('text', { x: xs[j], y: L.lettersY, 'text-anchor': 'middle', class: 'pp-skydia__label', fill: 'currentColor', stroke: 'none', 'font-size': L.font }, this.code);
      t.textContent = letters[j];
    }
    this.bars = [];
    var planets = (window.PPSkyCode && PPSkyCode.PLANETS) || ['mercury', 'venus', 'earth', 'mars', 'jupiter', 'saturn', 'uranus', 'neptune', 'pluto'];
    this.planets = planets;
    for (var b = 0; b < 9; b++) {
      if (planets[b] === 'earth') { this.bars.push(null); continue; }
      this.bars.push(svgEl('line', { x1: xs[b], x2: xs[b], stroke: 'currentColor', 'stroke-width': L.barW }, g));
    }
    this.morph = svgEl('path', { stroke: '#12A8E8' }, g);
    this.lo = L.top + 0.75 + 6;
    this.hi = L.base - 0.75 - 6;
    this.compute();
  };

  /* the date label: just outside the ring at Earth's place on the date, reading
     away from the Sun (rightward on the ring's right half, leftward on its left
     half, centred near its top and bottom), kept inside the drawing */
  Diagram.prototype.placeDate = function () {
    var t = this.dateLabel, L = this.L;
    var frac = this.days ? this.days.earth.frac : 0.5;
    var a = 2 * Math.PI * frac, c = Math.cos(a), s = Math.sin(a);
    var fs = L.font + 2, R = L.r + 13;
    var anchor = c > 0.35 ? 'start' : c < -0.35 ? 'end' : 'middle';
    var x = L.cx + R * c;
    var y = L.cy - R * s + (s > 0.35 ? -2 : s < -0.35 ? fs * 0.8 : fs * 0.35);
    var len = 0;
    try { len = t.getComputedTextLength(); } catch (e) { /* not laid out yet */ }
    if (!len) len = t.textContent.length * fs * 0.8;
    var lo = anchor === 'start' ? 2 : anchor === 'end' ? 2 + len : 2 + len / 2;
    var hi = anchor === 'start' ? L.W - 2 - len : anchor === 'end' ? L.W - 2 : L.W - 2 - len / 2;
    t.setAttribute('text-anchor', anchor);
    t.setAttribute('x', f2(clamp(x, lo, hi)));
    t.setAttribute('y', f2(clamp(y, fs, L.H - 2)));
  };

  /* points of an arc of length len from P, heading up, bending left with curvature k */
  function unroll(P, len, k, n) {
    var pts = [];
    for (var i = 0; i <= n; i++) {
      var s = len * i / n, along, side;
      if (k > 1e-6) { along = Math.sin(k * s) / k; side = (1 - Math.cos(k * s)) / k; }
      else { along = s; side = k * s * s / 2; }
      pts.push([P[0] - side, P[1] - along]);
    }
    return pts;
  }
  function pathOf(pts) {
    var d = 'M' + f2(pts[0][0]) + ' ' + f2(pts[0][1]);
    for (var i = 1; i < pts.length; i++) d += ' L' + f2(pts[i][0]) + ' ' + f2(pts[i][1]);
    if (pts.length === 1) d += ' L' + f2(pts[0][0]) + ' ' + f2(pts[0][1]);
    return d;
  }

  /* timeline (ms): ring 0-700, arc 700-1600, hold, unroll 1900-3200, bars rise 2100-3300 */
  Diagram.prototype.draw = function (ms) {
    this.lastT = ms;
    var L = this.L, cx = L.cx, cy = L.cy, r = L.r;
    var days = this.days;
    var frac = days ? days.earth.frac : 0.5;
    var full = this.hi - this.lo, w = L.barW;

    var pRing = clamp(ms / 700, 0, 1);
    var pArc = clamp((ms - 700) / 900, 0, 1);
    var pMorph = clamp((ms - 1900) / 1300, 0, 1);

    /* 1. the ring, drawn from the start line, the way the planets travel */
    var ringPts = [], th = 2 * Math.PI * easeEnter(pRing), n = Math.max(2, Math.ceil(96 * easeEnter(pRing)));
    for (var i = 0; i <= n; i++) { var a = th * i / n; ringPts.push([cx + r * Math.cos(a), cy - r * Math.sin(a)]); }
    this.ring.setAttribute('d', pRing > 0 ? pathOf(ringPts) : '');
    this.sun.setAttribute('opacity', easeEnter(pRing));
    this.tick.setAttribute('opacity', easeEnter(pRing));
    this.ringLabel.setAttribute('opacity', easeEnter(pRing));

    /* 2. the arc traveled by the date */
    var arcLen = 2 * Math.PI * r * frac;
    var shown = arcLen * easeTravel(pArc);
    var A = [cx + r, cy];
    var arcPts = unroll(A, shown, 1 / r, Math.max(1, Math.ceil(80 * frac * easeTravel(pArc))));
    this.arc.setAttribute('d', pArc > 0 ? pathOf(arcPts) : '');
    this.arc.setAttribute('stroke-opacity', pMorph > 0 ? lerp(1, 0.4, easeTravel(pMorph)) : 1);
    var ea = 2 * Math.PI * frac * easeTravel(pArc);
    this.earth.setAttribute('cx', f2(cx + r * Math.cos(ea)));
    this.earth.setAttribute('cy', f2(cy - r * Math.sin(ea)));
    this.earth.setAttribute('opacity', pArc > 0 ? 1 : 0);
    if (this.dateLabel) this.dateLabel.setAttribute('opacity', easeEnter(clamp((ms - 1450) / 450, 0, 1)));

    /* 3. the arc straightens into Earth's bar */
    var ei = this.planets.indexOf('earth');
    var h = Math.max(frac * full, w);
    var B = [this.xs[ei], this.hi - w / 2];
    if (pMorph > 0) {
      var e = easeTravel(pMorph);
      var P = [lerp(A[0], B[0], e), lerp(A[1], B[1], e)];
      var len = lerp(arcLen, Math.max(0, h - w), e);
      var k = (1 - e) / r;
      this.morph.setAttribute('d', pathOf(unroll(P, len, k, 80)));
      this.morph.setAttribute('stroke-width', f2(lerp(3, w, e)));
      this.morph.setAttribute('opacity', 1);
    } else {
      this.morph.setAttribute('d', '');
      this.morph.setAttribute('opacity', 0);
    }

    /* the rest of the code rises beside it */
    var pCode = clamp((ms - 1900) / 600, 0, 1);
    this.code.setAttribute('opacity', easeEnter(pCode));
    this.arrow.setAttribute('opacity', easeEnter(pCode) * 1);
    for (var b = 0; b < this.bars.length; b++) {
      var bar = this.bars[b];
      if (!bar) continue;
      var pb = clamp((ms - 2100 - b * 60) / 800, 0, 1);
      var fr = days ? days[this.planets[b]].frac : 0.5;
      var hb = Math.max(fr * full, w) * easeTravel(pb);
      bar.setAttribute('y1', f2(this.hi - w / 2));
      bar.setAttribute('y2', f2(this.hi - w / 2 - Math.max(0, hb - w)));
      bar.setAttribute('opacity', pb > 0 ? 1 : 0);
    }
  };

  Diagram.prototype.play = function () {
    if (this.played) return;
    this.played = true;
    this.playing = true;
    var self = this, t0 = null, END = 3400, run = this.run = (this.run || 0) + 1;
    var step = function (now) {
      if (run !== self.run) return;      /* started again (the homepage slides): the newer run draws */
      if (t0 === null) t0 = now;
      var ms = now - t0;
      self.draw(ms >= END ? Infinity : ms);
      if (ms < END) requestAnimationFrame(step);
      else self.playing = false;
    };
    requestAnimationFrame(step);
  };

  function initDiagrams(scope) {
    (scope || doc).querySelectorAll('[data-pp-skycode-diagram]').forEach(function (fig) {
      if (fig.ppDiagram) return;
      fig.ppDiagram = new Diagram(fig);
    });
  }

  /* ---- planet poster product page ------------------------------------------------ */
  function initPoster(root) {
    if (root.ppPoster) return;
    root.ppPoster = true;
    var data;
    try { data = JSON.parse(root.querySelector('[data-pp-variants]').textContent); } catch (_) { return; }
    var variants = data.variants || [];
    var currency = data.currency || 'CAD';
    var formatIndex = data.formatIndex, colorIndex = data.colorIndex, sizeIndex = data.sizeIndex;
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-pp-option]'));
    var idInput = root.querySelector('form input[name="id"]');
    var addBtn = root.querySelector('[data-pp-add]');
    var addLabel = addBtn && addBtn.querySelector('[data-pp-add-label]');
    var priceEl = root.querySelector('[data-pp-price]');
    var delivery = root.querySelector('[data-pp-delivery]');
    var gallery = root.querySelector('[data-pp-gallery]');
    var live = root.querySelector('[data-pp-variant-status]');

    function selections() {
      var sel = [];
      inputs.forEach(function (i) { if (i.checked) sel[+i.getAttribute('data-pp-option')] = i.value; });
      return sel;
    }
    function find(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < v.options.length; j++) if (v.options[j] !== sel[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function update(fromUser) {
      var sel = selections();
      var v = find(sel);
      /* format cards show their own price for this edition and size */
      if (formatIndex > -1) {
        root.querySelectorAll('[data-pp-format-price]').forEach(function (el) {
          var s2 = sel.slice(); s2[formatIndex] = el.getAttribute('data-pp-format-price');
          var fv = find(s2);
          el.textContent = fv ? money(fv.price, currency) : '';
        });
      }
      /* an option value with no available variant (given the others) is disabled */
      inputs.forEach(function (i) {
        var idx = +i.getAttribute('data-pp-option');
        var s3 = sel.slice(); s3[idx] = i.value;
        var fv = find(s3);
        i.disabled = !fv || !fv.available;
      });
      if (priceEl) priceEl.textContent = v ? money(v.price, currency) : 'Unavailable';
      if (idInput) { idInput.value = v ? v.id : ''; idInput.disabled = !v; }
      if (addBtn) {
        var can = !!(v && v.available);
        if (can) { addBtn.removeAttribute('disabled'); addBtn.removeAttribute('aria-disabled'); }
        else addBtn.setAttribute('disabled', 'disabled');
        if (addLabel) addLabel.textContent = !v ? 'Unavailable' : v.available ? 'Add to cart' : 'Sold out';
      }
      if (delivery && formatIndex > -1) {
        var f = sel[formatIndex];
        var msg = delivery.getAttribute('data-' + (f === 'Digital Download' ? 'digital' : f === 'Framed' ? 'framed' : 'frameless'));
        if (msg) delivery.textContent = msg;
      }
      if (v && fromUser) {
        try {
          var url = new URL(location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', url);
        } catch (_) { /* file previews can refuse */ }
        if (gallery && gallery.ppGo && v.media) gallery.ppGo(v.media, true);
        if (live) live.textContent = (sel[colorIndex] || '') + ' edition, ' + (sel[sizeIndex] || '').replace(/"/g, '').replace('x', ' by ') + ' inches, ' +
          (root.querySelector('[data-pp-format-name="' + sel[formatIndex] + '"]') || { textContent: sel[formatIndex] || '' }).textContent + ', ' + (v ? money(v.price, currency) : 'unavailable');
      }
    }
    inputs.forEach(function (i) { i.addEventListener('change', function () { update(true); }); });
    update(false);
  }


  // Finalized room photos, matched to the poster and edition. Product packshots remain available.
  var finalPosterPhotos = {"earth":[{"id":"pp-final-earth-black-12-ivory-mantel-lean-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-earth-black-12-ivory-mantel-lean-v1.png","w":1152,"h":1536,"alt":"Earth poster, black edition, ivory mantel lean"},{"id":"pp-final-earth-black-13-lilac-grey-sideboard-lean-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-earth-black-13-lilac-grey-sideboard-lean-v1.png","w":1152,"h":1536,"alt":"Earth poster, black edition, lilac grey sideboard lean"},{"id":"pp-final-earth-black-15-held-up-warm-grey-garden-view-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-earth-black-15-held-up-warm-grey-garden-view-v1.png","w":1152,"h":1536,"alt":"Earth poster, black edition, held up warm grey garden view"},{"id":"pp-final-earth-white-02-blue-gray-home-office-v1","edition":"white","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-earth-white-02-blue-gray-home-office-v1.png","w":1152,"h":1536,"alt":"Earth poster, white edition, blue gray home office"},{"id":"pp-final-earth-white-05-dusty-rose-sideboard-lean-v1","edition":"white","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-earth-white-05-dusty-rose-sideboard-lean-v1.png","w":1152,"h":1536,"alt":"Earth poster, white edition, dusty rose sideboard lean"},{"id":"pp-final-earth-white-07-held-up-butter-yellow-dining-v1","edition":"white","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-earth-white-07-held-up-butter-yellow-dining-v1.png","w":1152,"h":1536,"alt":"Earth poster, white edition, held up butter yellow dining"}],"jupiter":[{"id":"pp-final-jupiter-black-12-clay-kitchen-counter-lean-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-jupiter-black-12-clay-kitchen-counter-lean-v1.png","w":1152,"h":1536,"alt":"Jupiter poster, black edition, clay kitchen counter lean"},{"id":"pp-final-jupiter-black-15-held-up-warm-grey-living-room-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-jupiter-black-15-held-up-warm-grey-living-room-v1.png","w":1152,"h":1536,"alt":"Jupiter poster, black edition, held up warm grey living room"},{"id":"pp-final-jupiter-white-01-terracotta-breakfast-corner-v1","edition":"white","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-jupiter-white-01-terracotta-breakfast-corner-v1.png","w":1152,"h":1536,"alt":"Jupiter poster, white edition, terracotta breakfast corner"},{"id":"pp-final-jupiter-white-03-sunlit-landing-chest-v1","edition":"white","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-jupiter-white-03-sunlit-landing-chest-v1.png","w":1152,"h":1536,"alt":"Jupiter poster, white edition, sunlit landing chest"}],"mars":[{"id":"pp-final-mars-black-10-ivory-mantel-lean-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-mars-black-10-ivory-mantel-lean-v1.png","w":1152,"h":1536,"alt":"Mars poster, black edition, ivory mantel lean"},{"id":"pp-final-mars-black-11-held-up-pale-grey-entry-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-mars-black-11-held-up-pale-grey-entry-v1.png","w":1152,"h":1536,"alt":"Mars poster, black edition, held up pale grey entry"},{"id":"pp-final-mars-black-12-terrazzo-kitchen-counter-lean-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-mars-black-12-terrazzo-kitchen-counter-lean-v1.png","w":1152,"h":1536,"alt":"Mars poster, black edition, terrazzo kitchen counter lean"},{"id":"pp-final-mars-black-14-ivory-dining-nook-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-mars-black-14-ivory-dining-nook-v1.png","w":1152,"h":1536,"alt":"Mars poster, black edition, ivory dining nook"},{"id":"pp-final-mars-white-01-clay-breakfast-wall-v1","edition":"white","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-mars-white-01-clay-breakfast-wall-v1.png","w":1152,"h":1536,"alt":"Mars poster, white edition, clay breakfast wall"},{"id":"pp-final-mars-white-03-mushroom-reading-nook-v1","edition":"white","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-mars-white-03-mushroom-reading-nook-v1.png","w":1152,"h":1536,"alt":"Mars poster, white edition, mushroom reading nook"},{"id":"pp-final-mars-white-09-unwrapped-on-linen-bed-v1","edition":"white","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-mars-white-09-unwrapped-on-linen-bed-v1.png","w":1152,"h":1536,"alt":"Mars poster, white edition, unwrapped on linen bed"}],"mercury":[{"id":"pp-final-mercury-black-10-sunlit-cream-breakfast-table-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-mercury-black-10-sunlit-cream-breakfast-table-v1.png","w":1152,"h":1536,"alt":"Mercury poster, black edition, sunlit cream breakfast table"},{"id":"pp-final-mercury-black-11-lilac-grey-sideboard-lean-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-mercury-black-11-lilac-grey-sideboard-lean-v1.png","w":1152,"h":1536,"alt":"Mercury poster, black edition, lilac grey sideboard lean"},{"id":"pp-final-mercury-black-15-held-up-warm-grey-hall-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-mercury-black-15-held-up-warm-grey-hall-v1.png","w":1152,"h":1536,"alt":"Mercury poster, black edition, held up warm grey hall"},{"id":"pp-final-mercury-white-13-olive-sideboard-lean-v1","edition":"white","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-mercury-white-13-olive-sideboard-lean-v1.png","w":1152,"h":1536,"alt":"Mercury poster, white edition, olive sideboard lean"},{"id":"pp-final-mercury-white-14-sage-kitchen-counter-lean-v1","edition":"white","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-mercury-white-14-sage-kitchen-counter-lean-v1.png","w":1152,"h":1536,"alt":"Mercury poster, white edition, sage kitchen counter lean"},{"id":"pp-final-mercury-white-15-held-up-blue-grey-living-room-v1","edition":"white","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-mercury-white-15-held-up-blue-grey-living-room-v1.png","w":1152,"h":1536,"alt":"Mercury poster, white edition, held up blue grey living room"}],"neptune":[{"id":"pp-final-neptune-black-10-warm-white-mantel-lean-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-neptune-black-10-warm-white-mantel-lean-v1.png","w":1152,"h":1536,"alt":"Neptune poster, black edition, warm white mantel lean"},{"id":"pp-final-neptune-black-13-lilac-window-seat-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-neptune-black-13-lilac-window-seat-v1.png","w":1152,"h":1536,"alt":"Neptune poster, black edition, lilac window seat"},{"id":"pp-final-neptune-black-15-held-up-blush-bedroom-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-neptune-black-15-held-up-blush-bedroom-v1.png","w":1152,"h":1536,"alt":"Neptune poster, black edition, held up blush bedroom"},{"id":"pp-final-neptune-white-02-blue-grey-bedroom-v1","edition":"white","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-neptune-white-02-blue-grey-bedroom-v1.png","w":1152,"h":1536,"alt":"Neptune poster, white edition, blue grey bedroom"}],"pluto":[{"id":"pp-final-pluto-black-02-warm-bedroom-dresser-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-pluto-black-02-warm-bedroom-dresser-v1.png","w":1152,"h":1536,"alt":"Pluto poster, black edition, warm bedroom dresser"},{"id":"pp-final-pluto-black-10-lilac-window-seat-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-pluto-black-10-lilac-window-seat-v1.png","w":1152,"h":1536,"alt":"Pluto poster, black edition, lilac window seat"},{"id":"pp-final-pluto-black-11-held-up-dusty-pink-bedroom-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-pluto-black-11-held-up-dusty-pink-bedroom-v1.png","w":1152,"h":1536,"alt":"Pluto poster, black edition, held up dusty pink bedroom"},{"id":"pp-final-pluto-white-06-brick-plant-shop-v1","edition":"white","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-pluto-white-06-brick-plant-shop-v1.png","w":1152,"h":1536,"alt":"Pluto poster, white edition, brick plant shop"},{"id":"pp-final-pluto-white-07-held-up-powder-blue-living-room-v1","edition":"white","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-pluto-white-07-held-up-powder-blue-living-room-v1.png","w":1152,"h":1536,"alt":"Pluto poster, white edition, held up powder blue living room"}],"saturn":[{"id":"pp-final-saturn-black-10-marble-mantel-lean-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-saturn-black-10-marble-mantel-lean-v1.png","w":1152,"h":1536,"alt":"Saturn poster, black edition, marble mantel lean"},{"id":"pp-final-saturn-black-11-ivory-oak-sideboard-lean-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-saturn-black-11-ivory-oak-sideboard-lean-v1.png","w":1152,"h":1536,"alt":"Saturn poster, black edition, ivory oak sideboard lean"},{"id":"pp-final-saturn-black-15-held-up-lilac-entry-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-saturn-black-15-held-up-lilac-entry-v1.png","w":1152,"h":1536,"alt":"Saturn poster, black edition, held up lilac entry"},{"id":"pp-final-saturn-white-04-olive-dining-wall-v1","edition":"white","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-saturn-white-04-olive-dining-wall-v1.png","w":1152,"h":1536,"alt":"Saturn poster, white edition, olive dining wall"},{"id":"pp-final-saturn-white-06-taupe-mantel-lean-v1","edition":"white","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-saturn-white-06-taupe-mantel-lean-v1.png","w":1152,"h":1536,"alt":"Saturn poster, white edition, taupe mantel lean"}],"uranus":[{"id":"pp-final-uranus-black-11-taupe-sofa-detail-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-uranus-black-11-taupe-sofa-detail-v1.png","w":1152,"h":1536,"alt":"Uranus poster, black edition, taupe sofa detail"},{"id":"pp-final-uranus-black-12-lilac-marble-mantel-lean-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-uranus-black-12-lilac-marble-mantel-lean-v1.png","w":1152,"h":1536,"alt":"Uranus poster, black edition, lilac marble mantel lean"},{"id":"pp-final-uranus-white-01-sage-bedroom-corner-v1","edition":"white","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-uranus-white-01-sage-bedroom-corner-v1.png","w":1152,"h":1536,"alt":"Uranus poster, white edition, sage bedroom corner"},{"id":"pp-final-uranus-white-11-terracotta-sofa-corner-v1","edition":"white","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-uranus-white-11-terracotta-sofa-corner-v1.png","w":1152,"h":1536,"alt":"Uranus poster, white edition, terracotta sofa corner"},{"id":"pp-final-uranus-white-12-dusty-rose-sideboard-lean-v1","edition":"white","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-uranus-white-12-dusty-rose-sideboard-lean-v1.png","w":1152,"h":1536,"alt":"Uranus poster, white edition, dusty rose sideboard lean"}],"venus":[{"id":"pp-final-venus-black-01-ivory-dining-nook-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-venus-black-01-ivory-dining-nook-v1.png","w":1152,"h":1536,"alt":"Venus poster, black edition, ivory dining nook"},{"id":"pp-final-venus-black-12-held-up-lilac-dining-v1","edition":"black","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-venus-black-12-held-up-lilac-dining-v1.png","w":1152,"h":1536,"alt":"Venus poster, black edition, held up lilac dining"},{"id":"pp-final-venus-white-01-blue-living-room-v1","edition":"white","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-venus-white-01-blue-living-room-v1.png","w":1152,"h":1536,"alt":"Venus poster, white edition, blue living room"},{"id":"pp-final-venus-white-02-sage-dressing-corner-v1","edition":"white","src":"https://cdn.shopify.com/s/files/1/1002/8551/4006/files/pp-final-venus-white-02-sage-dressing-corner-v1.png","w":1152,"h":1536,"alt":"Venus poster, white edition, sage dressing corner"}]};
  function preparePosterPhotos(g) {
    var world = location.pathname.split('/').pop().replace(/-poster$/, '');
    var photos = finalPosterPhotos[world];
    // Refresh corrected Saturn images and thumbnails.
    var photoVersion = world === 'saturn' ? '&v=1792016957' : '';
    var root = g.closest('[data-pp-poster-product]');
    var track = g.querySelector('[data-pp-gallery-track]');
    var thumbs = g.querySelector('.pp-gallery__thumbs');
    if (!photos || !root || !track || !thumbs) return;
    var data;
    try { data = JSON.parse(root.querySelector('[data-pp-variants]').textContent); } catch (_) { return; }
    var chosen = root.querySelector('[data-pp-option="' + data.colorIndex + '"]:checked');
    var edition = chosen ? chosen.value.toLowerCase() : 'black';
    g.querySelectorAll('[data-pp-slide="room"], [data-pp-thumb="room"]').forEach(function (node) { node.remove(); });
    var figures = document.createDocumentFragment(), buttons = document.createDocumentFragment();
    photos.forEach(function (photo) {
      var figure = document.createElement('figure');
      figure.className = 'pp-gallery__slide pp-gallery__slide--room';
      figure.setAttribute('data-pp-slide', photo.id);
      figure.setAttribute('data-pp-photo-edition', photo.edition);
      var img = document.createElement('img');
      img.className = 'pp-gallery__img'; img.src = photo.src + '?width=1600' + photoVersion;
      img.srcset = [600,900,1200,1600].map(function (w) { return photo.src + '?width=' + w + photoVersion + ' ' + w + 'w'; }).join(', ');
      img.sizes = '(min-width: 990px) 52vw, 100vw'; img.alt = photo.alt;
      img.width = photo.w; img.height = photo.h; img.loading = 'lazy'; img.decoding = 'async';
      figure.appendChild(img); figures.appendChild(figure);
      var button = document.createElement('button'); button.type = 'button'; button.className = 'pp-gallery__thumb';
      button.setAttribute('data-pp-thumb', photo.id); button.setAttribute('aria-label', 'Show ' + photo.alt);
      button.setAttribute('data-pp-photo-edition', photo.edition);
      var mini = document.createElement('img'); mini.src = photo.src + '?width=160' + photoVersion; mini.alt = ''; mini.width=80; mini.height=100; mini.loading='lazy';
      button.appendChild(mini); buttons.appendChild(button);
    });
    track.insertBefore(figures, track.firstChild); thumbs.insertBefore(buttons, thumbs.firstChild);
    function matchEdition(tone) {
      g.querySelectorAll('[data-pp-photo-edition]').forEach(function (node) { node.hidden = node.getAttribute('data-pp-photo-edition') !== tone; });
      var first = photos.find(function (photo) { return photo.edition === tone; });
      if (first) { g.setAttribute('data-start', first.id); if (g.ppGo) g.ppGo(first.id, false); }
    }
    matchEdition(edition);
    // On edition changes show the matching finished mock; format/size still use their product packshots.
    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-pp-option="' + data.colorIndex + '"]')) {
        var tone = event.target.value.toLowerCase();
        requestAnimationFrame(function () { matchEdition(tone); });
      }
    });
  }

  function initGallery(g) {
    if (g.ppGallery) return;
    preparePosterPhotos(g);
    g.ppGallery = true;
    var trackEl = g.querySelector('[data-pp-gallery-track]');
    var slides = function () { return Array.prototype.slice.call(trackEl.querySelectorAll('[data-pp-slide]:not([hidden])')); };
    var thumbs = function () { return Array.prototype.slice.call(g.querySelectorAll('[data-pp-thumb]:not([hidden])')); };
    function current() {
      var s = slides(), x = trackEl.scrollLeft + trackEl.clientWidth / 2;
      for (var i = 0; i < s.length; i++) if (x >= s[i].offsetLeft && x < s[i].offsetLeft + s[i].offsetWidth) return i;
      return 0;
    }
    function mark(i) {
      var id = slides()[i] && slides()[i].getAttribute('data-pp-slide');
      thumbs().forEach(function (t) {
        var on = t.getAttribute('data-pp-thumb') === id;
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    }
    function go(id, smooth) {
      var s = slides();
      for (var i = 0; i < s.length; i++) {
        if (s[i].getAttribute('data-pp-slide') === String(id)) {
          trackEl.scrollTo({ left: s[i].offsetLeft, behavior: smooth ? behavior() : 'auto' });
          mark(i);
          return;
        }
      }
    }
    g.ppGo = go;
    g.addEventListener('click', function (e) {
      var t = e.target.closest('[data-pp-thumb]');
      if (t) go(t.getAttribute('data-pp-thumb'), true);
      var step = e.target.closest('[data-pp-step]');
      if (step) {
        var s = slides(), i = clamp(current() + (+step.getAttribute('data-pp-step')), 0, s.length - 1);
        if (s[i]) go(s[i].getAttribute('data-pp-slide'), true);
      }
    });
    var tk = false;
    trackEl.addEventListener('scroll', function () {
      if (tk) return;
      tk = true;
      requestAnimationFrame(function () { tk = false; mark(current()); });
    }, { passive: true });
    trackEl.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      var s = slides(), i = clamp(current() + (e.key === 'ArrowRight' ? 1 : -1), 0, s.length - 1);
      if (s[i]) go(s[i].getAttribute('data-pp-slide'), true);
    });
    var start = g.getAttribute('data-start');
    if (start) requestAnimationFrame(function () { go(start, false); });
    else mark(0);
  }

  /* ---- small live orrery, loaded as it approaches ------------------------------------ */
  function initMiniOrrery(host) {
    if (host.ppMini) return;
    host.ppMini = true;
    var today = todayISO();
    var section = host.closest('section') || doc;
    section.querySelectorAll('[data-pp-today]').forEach(function (n) { n.textContent = formatDate(today).toUpperCase(); });
    var start = function () {
      var make = function () {
        if (!window.PPOrrery) return;
        try {
          host.ppOrrery = window.PPOrrery.create(host, { theme: 'black', fit: 'system', rules: false, watermark: null, date: today, starDensity: 0.7 });
          host.classList.add('is-ready');
        } catch (e) { /* the copy and button still work without the drawing */ }
      };
      if (window.PPOrrery) { make(); return; }
      var src = host.getAttribute('data-src');
      if (!src) return;
      var existing = doc.querySelector('script[data-pp-orrery-src]');
      if (existing) { existing.addEventListener('load', make); return; }
      var s = doc.createElement('script');
      s.src = src; s.async = true; s.setAttribute('data-pp-orrery-src', '');
      s.addEventListener('load', make);
      doc.head.appendChild(s);
    };
    onView(host, start, { rootMargin: '300px 0px', threshold: 0 });
  }

  /* ---- annotations draw on entry ---------------------------------------------------- */
  function initAnnos(scope) {
    (scope || doc).querySelectorAll('[data-pp-anno]').forEach(function (a) {
      if (a.ppAnno) return;
      a.ppAnno = true;
      if (reduce.matches) { a.classList.add('is-drawn'); return; }
      onView(a, function () { a.classList.add('is-drawn'); }, { rootMargin: '0px 0px -10% 0px', threshold: 0.6 });
    });
  }

  /* ---- studio cross-sell: carry the shopper's date to the other studio ------------- */
  function initCrossSell(scope) {
    var links = (scope || doc).querySelectorAll('[data-pp-crosssell]');
    if (!links.length) return;
    function refresh() {
      links.forEach(function (a) {
        var to = a.getAttribute('data-pp-crosssell');
        var base = a.getAttribute('data-base') || a.getAttribute('href').split('?')[0];
        a.setAttribute('data-base', base);
        var from = doc.querySelector(to === 'case' ? 'pp-print-customizer' : 'pp-case-customizer');
        var field = from && from.querySelector('[data-date]');
        var date = field && validISO(field.value) ? field.value : '';
        var q = [];
        if (date) q.push('pp_date=' + encodeURIComponent(date));
        if (to === 'case' && from) {
          var color = from.getAttribute('data-preview-color');
          if (color === 'black' || color === 'white') q.push('pp_edition=' + color);
        }
        a.setAttribute('href', base + (q.length ? '?' + q.join('&') : ''));
        var host = a.closest('section');
        var carry = host && host.querySelector('[data-pp-carry]');
        if (carry) carry.hidden = !date;
      });
    }
    doc.addEventListener('pp:studio-update', refresh);
    links.forEach(function (a) { a.addEventListener('pointerdown', refresh); a.addEventListener('focus', refresh); });
    refresh();
  }

  /* ---- boot ------------------------------------------------------------------------ */
  function boot(scope) {
    var s = scope || doc;
    initImages(s);
    s.querySelectorAll('[data-pp-lineup]').forEach(initLineup);
    initDiagrams(s);
    s.querySelectorAll('[data-pp-gallery]').forEach(initGallery);
    s.querySelectorAll('[data-pp-poster-product]').forEach(initPoster);
    s.querySelectorAll('[data-pp-mini-orrery]').forEach(initMiniOrrery);
    initAnnos(s);
    initCrossSell(s);
  }

  window.PPProduct = { boot: boot, money: money };

  /* Deferred scripts run before DOMContentLoaded; pp-skycode.js may come after this
     file, so wait for it. Every init above is idempotent. */
  if (doc.readyState === 'complete') boot();
  else {
    doc.addEventListener('DOMContentLoaded', function () { boot(); });
    window.addEventListener('load', function () { boot(); });
  }
  doc.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
